
import { mapMutations } from "vuex";
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Lipid_unit_conversion",
components: {
XTable
},
data() {
return {
form: {
value1: "",
},
form1: {
value1: "",
},
form2: {
value1: "",
},
form3: {
value1: "",
},
hasScore: false,
disabled: false,
};
},
created() {
this.hideLoad();
},
methods: {
...mapMutations(["hideLoad"]),
},
computed: {
/** 计算公式结果 */
score() {
let self = this;
let form = JSON.parse(JSON.stringify(self.form));
let flag = true;
for (const key in form) {
if (form.hasOwnProperty(key)) {
if (!form[key]) {
flag = false;
} else {
if (form[key] == "---") {
flag = false;
} else {
form[key] = Number(form[key]);
}
}
}
}
if (!flag) {
self.hasScore = false;
return "--";
} else {
let result = form.value1;
self.hasScore = true;
return String(result.toFixed(1));
}
},
score1() {
let self = this;
let form1 = JSON.parse(JSON.stringify(self.form1));
let flag = true;
for (const key in form1) {
if (form1.hasOwnProperty(key)) {
if (!form1[key]) {
flag = false;
} else {
if (form1[key] == "---") {
flag = false;
} else {
form1[key] = Number(form1[key]);
}
}
}
}
if (!flag) {
self.hasScore = false;
return "--";
} else {
let result = form1.value1;
self.hasScore = true;
return String(result.toFixed(1));
}
},
score2() {
let self = this;
let form2 = JSON.parse(JSON.stringify(self.form2));
let flag = true;
for (const key in form2) {
if (form2.hasOwnProperty(key)) {
if (!form2[key]) {
flag = false;
} else {
if (form2[key] == "---") {
flag = false;
} else {
form2[key] = Number(form2[key]);
}
}
}
}
if (!flag) {
self.hasScore = false;
return "--";
} else {
let result = form2.value1;
self.hasScore = true;
return String(result.toFixed(1));
}
},
score3() {
let self = this;
let form3 = JSON.parse(JSON.stringify(self.form3));
let flag = true;
for (const key in form3) {
if (form3.hasOwnProperty(key)) {
if (!form3[key]) {
flag = false;
} else {
if (form3[key] == "---") {
flag = false;
} else {
form3[key] = Number(form3[key]);
}
}
}
}
if (!flag) {
self.hasScore = false;
return "--";
} else {
let result = form3.value1;
self.hasScore = true;
return String(result.toFixed(1));
}
},
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Lipid_unit_conversion.vue